import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Grid, Menu, Segment } from 'semantic-ui-react';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';
import './index.scss'

const ROUTES = {
    callRecording: 'call-recording',
    callerId: 'caller-id',
    e911Location: 'e911-location',
    tcr: 'tcr',
    preferences: 'preferences',
    holidaySchedule: 'holiday-schedule'
}

const General = () => {
    return <Grid>
        <Grid.Row style={{ paddingTop: 0, paddingBottom: 0 }}>
            <Grid.Column style={{ paddingTop: '1em', paddingRight: 0, paddingLeft: '0.5em' }}>
                <Menu secondary className='PhoneManagement_generalTabs'>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW} productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}general/${ROUTES.callRecording}`}>
                        <Menu.Item name='Call Recording' as={NavLink} to={ROUTES.callRecording} />
                    </RestrictedView>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW} productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}general/${ROUTES.callerId}`}>
                        <Menu.Item name='Caller ID' as={NavLink} to={ROUTES.callerId} />
                    </RestrictedView>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW} productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}general/${ROUTES.e911Location}`}>
                        <Menu.Item name='E911 Location' as={NavLink} to={ROUTES.e911Location} />
                    </RestrictedView>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW} productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}general/${ROUTES.holidaySchedule}`}>
                        <Menu.Item name='Holiday Schedule' as={NavLink} to={ROUTES.holidaySchedule} />
                    </RestrictedView>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW} productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}general/${ROUTES.preferences}`}>
                        <Menu.Item name='Preferences' as={NavLink} to={ROUTES.preferences} />
                    </RestrictedView>
                </Menu>
                <Segment basic>
                    <Outlet />
                </Segment>
            </Grid.Column>
        </Grid.Row>
    </Grid>;
}

export default General;